
// @ts-nocheck


export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_0d2ce274",
      load: () => import("#nuxt-i18n/0d2ce274" /* webpackChunkName: "locale_en_46json_0d2ce274" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_38b46529",
      load: () => import("#nuxt-i18n/38b46529" /* webpackChunkName: "locale_da_46json_38b46529" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_79894d18",
      load: () => import("#nuxt-i18n/79894d18" /* webpackChunkName: "locale_de_46json_79894d18" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_b4b51520",
      load: () => import("#nuxt-i18n/b4b51520" /* webpackChunkName: "locale_es_46json_b4b51520" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_4b234037",
      load: () => import("#nuxt-i18n/4b234037" /* webpackChunkName: "locale_fi_46json_4b234037" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_f03336f3",
      load: () => import("#nuxt-i18n/f03336f3" /* webpackChunkName: "locale_fr_45CA_46json_f03336f3" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_b8f4f2f0",
      load: () => import("#nuxt-i18n/b8f4f2f0" /* webpackChunkName: "locale_fr_45FR_46json_b8f4f2f0" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_2b50e343",
      load: () => import("#nuxt-i18n/2b50e343" /* webpackChunkName: "locale_it_46json_2b50e343" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_1be43eac",
      load: () => import("#nuxt-i18n/1be43eac" /* webpackChunkName: "locale_nl_46json_1be43eac" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_5e94fdc1",
      load: () => import("#nuxt-i18n/5e94fdc1" /* webpackChunkName: "locale_no_46json_5e94fdc1" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_f3015957",
      load: () => import("#nuxt-i18n/f3015957" /* webpackChunkName: "locale_pt_45BR_46json_f3015957" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_ad59cade",
      load: () => import("#nuxt-i18n/ad59cade" /* webpackChunkName: "locale_pt_45PT_46json_ad59cade" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_f02a3722",
      load: () => import("#nuxt-i18n/f02a3722" /* webpackChunkName: "locale_sv_46json_f02a3722" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-CA",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fr-CA.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-FR",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-BR",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/pt-BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-PT",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      files: [
        {
          path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/sv.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-CA",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fr-CA.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-FR",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-BR",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/pt-BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-PT",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    files: [
      {
        path: "/tmp/workspace/staging/revex/memberships-preview/apps/clientportal/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/